import { PRACTICE_TIMER_TYPES } from 'src/consumer/constants'
import { GenericTimerTypeTabButton, GenericTimerTypeTabsContainer } from './styledComponents'

const TIMER_TAB_DATA = [
  {
    type: PRACTICE_TIMER_TYPES.unlimited,
    content: '∞',
  },
  {
    type: PRACTICE_TIMER_TYPES.fixed,
    content: 'Fixed Timer',
  },
  {
    type: PRACTICE_TIMER_TYPES.range,
    content: 'Range Timer',
  },
]

export default function TimerTypeSelection({ timerType, setTimerType, containerStyles = {} }) {
  return (
    <GenericTimerTypeTabsContainer style={containerStyles}>
      {TIMER_TAB_DATA?.map((tmrType) => (
        <GenericTimerTypeTabButton
          key={tmrType?.type}
          onClick={() => setTimerType(tmrType?.type)}
          selected={tmrType?.type === timerType}
        >
          {tmrType?.content}
        </GenericTimerTypeTabButton>
      ))}
    </GenericTimerTypeTabsContainer>
  )
}
